<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import BaseCluster from '~/components/foundations/BaseCluster.vue'

export type BreadcrumbItem = {
  text: string
  to?: RouteLocationRaw
}

defineProps<{
  items: BreadcrumbItem[]
}>()
</script>

<template>
  <nav class="breadcrumb-nav" aria-label="breadcrumbs">
    <ol>
      <BaseCluster align="center">
        <template v-for="item in items" :key="item.text">
          <li v-if="item.to">
            <NuxtLink :to="item.to" class="link">{{ item.text }}</NuxtLink>
          </li>
          <li v-else>
            {{ item.text }}
          </li>
        </template>
      </BaseCluster>
    </ol>
  </nav>
</template>

<style lang="scss" scoped>
.breadcrumb-nav {
  ol {
    list-style: none;
    @include textToken.body-small;

    :deep(.cluster) {
      flex-wrap: wrap;
    }

    .link {
      color: var(--semantic-tokens-neutral-default-text);
      text-decoration: none;
    }
  }

  li {
    flex-shrink: 0;
  }

  li + li::before {
    content: '>';
    padding: 0 spacingToken.$spacing-xs;
    color: var(--semantic-tokens-neutral-default-text);
  }

  li:last-child {
    @include textToken.label-medium;
  }
}
</style>
